import React, { ReactNode, useEffect } from 'react';
import { Card } from '../../Layout/Card';
import { CompletableText } from './CompletableText';
import { Icons } from '../../Icons/Icons';
import { IHaveItems } from '../../../../../ViewModel/Services/ItemsManager';
import { SimpleTextViewModel } from '../../../../../ViewModel';
import { TutorialFlyout } from '../../TutorialFlyout';
import { GLStep } from '../../../../../ViewModel/TutorialStateViewModel';

export type style = 'none' | 'line-through';

interface CompletableTextProps {
    title: string;
    entries: IHaveItems<SimpleTextViewModel>;
    headerIcon?: ReactNode;
    style?: style;
    tutorialSteps?: GLStep[];
    className?: string;
}


export const CompletableTextGroup: React.FC<CompletableTextProps> = ({ entries, title, headerIcon, style, tutorialSteps, className }) => {

    const [allEntries, setAllEntries] = React.useState<SimpleTextViewModel[]>([]);
    const [showGroup, setShowGroup] = React.useState<boolean>(false);

    //
    // This is the useEffect that will run when the component is mounted
    //
    useEffect(() => {

        const onEntriesChanged = async () => {
            setAllEntries(entries.values);

            for (let entry of entries.values) {
                if (entry.TypedData.text.length > 0) {
                    setShowGroup(true);
                    return;
                }
            }
        };
        entries.PropertyChanged.Subscribe(onEntriesChanged);
        onEntriesChanged();

        //
        // Do the final clean up
        //
        return () => {
            entries.PropertyChanged.Unsubscribe(onEntriesChanged);
        }
    }, []);

    if (!showGroup) {
        return (<></>);
    }

    const header = headerIcon ? headerIcon : <Icons.CardBulletIcon className='gl-group-header-icon' />;

    return (
        <div className={`gl-list CompletableTextGroup ${className}`}>
            {allEntries.length > 0 && <>

                <Card noMargin disableClick>
                    <TutorialFlyout steps={tutorialSteps}>
                        <div className='flex flex-row justify-content-start align-items-center mb-3'>
                            {header}
                            <p className='gl-list-header-spacing gl-content-header-typography'>{title}</p>
                        </div>
                    </TutorialFlyout>
                    {
                        allEntries.map((entry, index) => (
                            entry.TypedData.text.length > 0 && <CompletableText style={style} key={entry.TypedData.key} number={index + 1} text={entry} />
                        ))
                    }

                </Card >
            </>
            }
        </div>
    );
};